app.directive('tabItem', function() {
	return {
		scope: {},
		restrict: 'AE',
		require: '^tabSet',
		transclude: true,
		replace: true,
		template: '<div ng-show="active && !hidden" ng-transclude></div>',
		link: function(scope, elem, attrs, controllerInstance) {
			scope.active = false;
			scope.hidden = false;

			if(attrs.initHidden) {
				scope.hidden = true;
				scope.$on('tabNotEmpty', function(events, id) {
					if(id == attrs.id) {
						scope.hidden = false;
						controllerInstance.checkActive(scope);
					}
				});
			}

			scope.title = attrs.titletext;
			scope.element = elem[0];
			scope.url = attrs.url;
			controllerInstance.addTab(scope);
		}
	};
});